import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';

import { ButtressEntity } from '@buttress/crag';

import NSJobComponent from '../../job.js';
import JobSchema from '../../../../models/job-schema.js';
import '../../../../ns-elements/ns-job-layout.js';
import '@awesome.me/webawesome/dist/components/button/button.js';
import definition from '@job-schemas/subscription/authorise-card-use-feedback.json';
import { jobSchema } from '../../job-schema.js';

interface PaymentMethod {
  id: string;
  ownerId: string;
  type: string;
  brand: string;
  last4: string;
  active: boolean;
}

@customElement(NSAuthoriseSubscriptionCardUseFeedback.is)
export default class NSAuthoriseSubscriptionCardUseFeedback extends NSJobComponent {
  static get is() {
    return 'ns-authroise-subscription-card-use-feedback';
  }

  private __subscription?: ButtressEntity;

  @state()
  private __selectedCard?: PaymentMethod;

  @state()
  private __feedback?: string;

  static get schema(): JobSchema {
    return jobSchema(definition, { outcomes: { complete: { type: 'hidden' } } });
  }

  async connectedCallback() {
    await super.connectedCallback();

    if (!this._db) throw new Error('Unable to find db service');

    if (!this._auth) throw new Error('Unable to find auth service');

    if (!this._job) throw new Error('Unable to find job');

    if (!this._directory) throw new Error('Directory service not found');
    if (!this._directory.me || !this._directory.me.companyId)
      throw new Error('Company id not found in the directory service');

    this.__subscription = await this.loadInput('subscription', 'subscriptionId');

    this.__selectedCard = this.__subscription.paymentMethods.find(
      (p: PaymentMethod) => p.id === this._job?.inputValues.paymentMethodId,
    );

    this.__feedback = this._job.inputValues.feedback as string;
  }

  render() {
    return html`
      <ns-job-layout>
        <div class="job-panel">
          ${when(
            this.__feedback === 'ACCEPTED',
            () => html`
              <p>
                Your request to use the card that ends with ${this.__selectedCard?.last4} to be the default payment for
                the nodeStream subscription has been accepted.
              </p>
            `,
            () => html`
              <p>
                Your request to use the card that ends with ${this.__selectedCard?.last4} to be the default payment for
                the nodeStream subscription has been rejected. If you still want to change the default payment method to
                the nodeStream subscription please head back to subscription management.
              </p>
            `,
          )}
        </div>
      </ns-job-layout>
    `;
  }

  renderActions() {
    return html`
      <wa-button variant="brand" type="button" @click=${() => this.outcome('complete')}>Complete</wa-button>
    `;
  }
}
